/*!
 *  BUI 简介 
 *  
 *  v1.1.2 date: 2016-10-13
 *  
 *  BUI 是 Button UI 的简称,以 Button 为中心的UI框架, 
 *  在按钮的基础上嵌入布局扩展大量的常用控件, 
 *  只要进行简单的组装,就能快速开发应用,
 *  并能保持PC跟手机端的调试一致,效果一致,开发一致.
 *  
 *  BUI 专注于移动开发体验(包括不限于Bingotouch,link,微信,及webapp开发)
 *  -----------------------------------------------------------
 *  BUI Team
 *  部门: 政企体验创新部
 *  产品经理: 区柏荣
 *  代码设计: 王伟深 杨俊标
 *  产品设计师: 邝德如 范菊 唐竹晗
 *  -----------------------------------------------------------
 *  BUI 反馈邮箱: wangwsh@bingosoft.net
 *
 *  Copyright (c) 2016
 */

/**
 * <h5>核心</h5>
 * {{#crossLink "bui.ready"}}{{/crossLink}}: 控件的初始化都要在这个回调里面 <br>
 * {{#crossLink "bui.viewport"}}{{/crossLink}}: 页面的rem自适应,在bui.ready已经初始化 <br> 
 * {{#crossLink "bui.require"}}{{/crossLink}}: 控件的引用及扩展,比方loading 有时候只是想引用,而不想生成loading,则可以使用require <br> 
 * @module  Core
 */

//依赖库
var libs = Zepto; //如果使用jQuery,需要在这里修改,但同时一些jquery不支持的事件也会不能使用,例如longTap,touchstart
//UI库
var bui = (function ($,window) {

    var ui = {};

    //是否开启调试模式 PC或者微信及webapp 使用true; sso登录使用 false;
    ui.debug = true;

/* bui基本属性配置 
--------------------------------*/ 
    ui.config = {};

    // ui名称
    ui.config.namespace = "bui";

    // ui前缀
    ui.config.classNamePrefix = ui.config.namespace + "-";
    
    // 版本号
    ui.config.version = "1.1.2";
    ui.config.versionCode = 20161013;

/* 常用控件全局属性配置 
--------------------------------*/    
    //全局

    //弹出框全局配置
    ui.config.dialog = {};
    //确认框全局配置
    ui.config.confirm = {};
    //提醒框全局配置
    ui.config.alert = {};
    //消失提醒框
    ui.config.hint = {};
    ui.config.loading = {};
    ui.config.mask = {};
    ui.config.list = {};
    ui.config.listview = {};
    ui.config.scroll = {};
    ui.config.pullrefresh = {};
    ui.config.select = {};
    ui.config.sidebar = {};
    ui.config.slide = {};
    ui.config.actionsheet = {};
    ui.config.dropdown = {};
    ui.config.accordion = {};
    ui.config.stepbar = {};
    ui.config.rating = {};
    ui.config.number = {};
    ui.config.file = {};


    /*
     * [prefix ui前缀生成器]
     * @param  {[type]} classname [description]
     * @return {[type]}     [description]
     */
    ui.prefix = function (className) {
        return ui.config.classNamePrefix + className;
    }



/*----------------------
  控件引用及依赖管理器
----------------------*/      
    /**
     *  require 引用及扩展已有的接口方法,通过require引用以后，可以不用先初始化 
     *  @namespace bui
     *  @class require
     *  @constructor 
     *  @param {string} moduleName [引用模块的名字]
     *  @param {function} [callback] [定义模块的新方法]
     *  @example
        //定义loading扩展add方法
        var uiLoading = bui.require("loading.add",function(widget){

            var uiLoading = widget;
            
            //使用已有的旧方法
            uiLoading()//.start().stop();
        });
        //引用
        var loading = bui.require("loading");

        //调用新增的app方法
        loading.add();
    */
    ui.require = function (moduleName,callback) {

        var parts = [],
            parts = moduleName.split('.'),
            module = ui,
            i;

        // 默认如果第一个节点是bui的话，就忽略掉，比如bui.ModuleA
        if (parts[0] === "bui") {
            parts = parts.slice(1);
        }
        for (i = 0; i < parts.length; i += 1) {
            // 如果属性不存在，就创建
            if (typeof module[parts[i]] === "undefined") {
                module[parts[i]] = function (argument) {
                    //把控件已有的接口方法拿过去回调用
                    callback && callback( ui.widget(parts[0]) );
                };
            }
            //如果存在就直接引用
            module = module[parts[i]];
            
        }
        return module;
    };

    /*
     *  滑动方向判断 控件相关
     *  @namespace bui
     *  @class swipeDirection
     *  @constructor 
     *  @param {number} x1 [ x轴按下的位置 ]
     *  @param {number} x2 [ x轴按下移动的位置 ]
     *  @param {number} y1 [ y轴按下的位置 ]
     *  @param {number} y2 [ y轴按下移动的位置 ]
     *  @example
        
        var direction = bui.swipeDirection(x1,x2,x3,x4);
    */
    ui.swipeDirection = function (x1, x2, y1, y2) {
        var xDif = x2-x1,
            yDif = y2 - y1,
            xAbs = Math.abs(xDif),
            yAbs = Math.abs(yDif),
            distance = 9,  //移动的距离
            angle = 3;

            if(xAbs<distance&&yAbs<distance){
              return false;
            }
            if(xAbs / yAbs > angle){
              //左右
              return xDif>0?'swipeRight':'swipeLeft';
            }else{
              // 上下
              return yDif>0?'swipeDown':'swipeUp';
            }
    }

    //控件公共方法 未使用
    ui.widgetMethod = function (){
      this.config={};
      this.widget=function(name){
        return null;
      };
      this.option=function(key,value){
        return ui.option.call(this,key,value);
      };
      this.init=function(){};
    }

    //控件的内部依赖
    ui.widget = function(name) {
      if( typeof name === "string" && this[name] ){
          return this[name];
      }
      return this;
    }

    //控件的参数设置及获取,供控件调用
    ui.option = function (key,value) {

        if(this.config.hasOwnProperty(key) && typeof value !== "undefined"){
            var obj = {}; 
                obj[key] = value;

            var opt = $.extend({}, this.config, obj );
            this.init(opt);
        //如果更换为jQuery库,这个Object.prototype.toString.call判断会有问题
        }else if( Object.prototype.toString.call(key) === "[object Object]" ){
            var opt = $.extend({}, this.config, key);

            this.init(opt);
        }else if( this.config.hasOwnProperty(key) && typeof value === "undefined"){
            return this.config[key];
        }else{
            return this.config;
        }

        return this;
    }
/*----------------------
  事件管理
----------------------*/

    
    /*
     *  事件派发管理器
     *  @namespace bui
     *  @class dispatchEvent
     *  @constructor 
     *  @param {object} dom [ dom对象 ]
     *  @param {string} eventName [ 事件 ]
     *  @param {object} detail [ 对象 ]
     *  @example
        
        ui.dispatchEvent(sidebar,'sidebarOpen',{id:,state})
    */
    ui.dispatchEvent = function(dom, eventName, detail) {
      if (dom && dom.dispatchEvent && eventName) {
        dom.dispatchEvent(new Event(eventName, {
          bubbles: true,
          cancelable: true,
          detail: detail
        }));
      }
    };

    /*
     *  绑定事件
     *  @namespace bui
     *  @class on
     *  @constructor 
     *  @param {string} events [支持 touchstart touchmove touchend click ]
     *  @param {object} el [ dom对象 ]
     *  @param {function} callback [回调]
     *  @param {boolean} [useCapture] [定义模块的新方法]
     *  @example
        
        bui.on("touchstart",document,function(e){
          console.log(e)
        })
    */
    ui.on = function (events,el,callback,useCapture) {
      //滑动兼容处理
      var isTouchPad = (/hp-tablet/gi).test(navigator.appVersion),
          hasTouch = 'ontouchstart' in window && !isTouchPad, 
          touchStart = hasTouch ? 'touchstart': 'mousedown',  
          touchMove = hasTouch ? 'touchmove': 'mousemove',  
          touchEnd = hasTouch ? 'touchend': 'mouseup',
          el = el,
          useCapture = useCapture == true ? true : false, //事件捕获,默认冒泡
          callback = callback || function() {};

          var i;
          for( i=0; i< (el.length || 0); i++){

            switch(events){
                case "touchstart":

                el[i].addEventListener(touchStart, callback ,useCapture);
                break;
                case "touchmove":
                el[i].addEventListener(touchMove, callback ,useCapture);
                break;
                case "touchend":
                
                el[i].addEventListener(touchEnd, callback ,useCapture);
                //兼容PC处理 把PC的鼠标移到窗口外面当做鼠标松开处理,pc的 sidebar listview 控件存在这个问题
                if(touchEnd=='mouseup'){
                  document.documentElement.addEventListener('mouseleave',callback,useCapture);
                }
                break;
                default:

                el[i].addEventListener(events, callback ,useCapture);
            }

          }
        
    };

    /*
     *  关闭事件
     *  @namespace bui
     *  @class off
     *  @constructor 
     *  @param {string} events [支持 touchstart touchmove touchend click ]
     *  @param {object} el [ dom对象 ]
     *  @param {function} callback [回调]
     *  @param {boolean} [useCapture] [定义模块的新方法]
     *  @example
        
        bui.off("touchstart",document,function(e){
          console.log(e)
        })
    */
    ui.off = function (events,el,callback,useCapture) {
      //滑动兼容处理
      var isTouchPad = (/hp-tablet/gi).test(navigator.appVersion),
          hasTouch = 'ontouchstart' in window && !isTouchPad, 
          touchStart = hasTouch ? 'touchstart': 'mousedown',  
          touchMove = hasTouch ? 'touchmove': 'mousemove',  
          touchEnd = hasTouch ? 'touchend': 'mouseup',
          el = el,
          useCapture = useCapture == true ? true : false, //事件捕获,默认冒泡
          callback = callback || function() {};

          var i;
          for( i=0; i< el.length; i++){
            switch(events){
                case "touchstart":
                el[i].removeEventListener(touchStart, callback ,useCapture);
                break;
                case "touchmove":
                el[i].removeEventListener(touchMove, callback ,useCapture);
                break;
                case "touchend":
                el[i].removeEventListener(touchEnd, callback ,useCapture);
                  //兼容PC处理 把PC的鼠标移到窗口外面当做鼠标松开处理,pc的 sidebar listview 控件存在这个问题
                  if(touchEnd=='mouseup'){
                    document.documentElement.removeEventListener('mouseleave',callback,useCapture);
                  }
                break;
                default:
                el[i].addEventListener(events, callback ,useCapture);
            }
          }
    };

    return ui;

})(libs,window);

// 解决滑动控件 touchmove 过程中触发元素的click事件 
;(function(){

     //滑动兼容处理
    var isTouchPad = (/hp-tablet/gi).test(navigator.appVersion),
        hasTouch = 'ontouchstart' in window && !isTouchPad, 
        touchStart = hasTouch ? 'touchstart': 'mousedown',  
        touchMove = hasTouch ? 'touchmove': 'mousemove',  
        touchEnd = hasTouch ? 'touchend': 'mouseup',
        ismoving = false,
        hasdown = false;

    document.documentElement.addEventListener(touchStart,function(e){
        hasdown = true;
    },true);

    document.documentElement.addEventListener(touchMove,function(e){
        ismoving=hasdown;
    },true);

    //移动端
    document.documentElement.addEventListener("touchend",function(e){
        //ismoving true 导致移动端需要点2次才会关闭,false变成无法阻止滑动不点击.
        ismoving = false;
        hasdown = false;

    },true);
    //PC端
    document.documentElement.addEventListener('click',function(e){
        if(ismoving){
            e.stopPropagation();
        }
        ismoving = false;
        hasdown = false;
    },true);

})();
